import React from 'react'

import Login from './Login'

export function LoginWithSeo(props: React.ComponentProps<typeof Login>) {
	return (
		<>
			{/* eslint-disable-next-line i18next/no-literal-string */}
			<title>Log in to your GetGoing account here</title>
			<meta
				name="description"
				content="Welcome to the GetGoing login page. Here, you can sign in to your GetGoing account. Lost your GetGoing password ? Click on Forgot Password to reset it."
			/>
			<Login {...props} />
		</>
	)
}
